import React from 'react';
import { CTAButton } from '../CTAButton';
import { stats } from '../../data/content';
export function StatsBand() {
  return <section className="w-full bg-white py-12 sm:py-16" data-id="element-341" data-mp="3buij2tj1za9e">
      <div className="mx-auto w-full max-w-5xl px-5" data-id="element-342" data-mp="2y4oqc04fg5ue">
        <div className="grid gap-6 sm:grid-cols-2" data-id="element-343" data-mp="2y46moiffqpcg">
          {stats.map(stat => <article key={stat.value} className="flex flex-col border-l-4 border-brand-500 pl-4 sm:pl-5" data-id="element-344" data-mp="324h4csclb475">
              <p className="font-display text-4xl font-extrabold leading-none text-navy-900 sm:text-5xl" data-id="element-345" data-mp="2t5c33e9n8wra">
                {stat.value}
              </p>
              <h3 className="mt-2 text-[0.8rem] font-bold uppercase leading-snug tracking-[0.08em] text-brand-700" data-id="element-346" data-mp="2f75fqs2bmf5v">
                {stat.label}
              </h3>
              <p className="mt-2 text-[0.92rem] leading-relaxed text-slate-600" data-id="element-347" data-mp="ddo83oe6xeb4">
                {stat.description}
              </p>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-348" data-mp="qz0rldz8t5q6">
          <CTAButton label="I want the complete Clinical Route" note="Immediate access · One-time payment" data-id="element-349" data-mp="qxpnte5srxz2" />
        </div>
      </div>
    </section>;
}